import { render, staticRenderFns } from "./sendRecord.vue?vue&type=template&id=34c66d8e&scoped=true"
import script from "./sendRecord.vue?vue&type=script&lang=js"
export * from "./sendRecord.vue?vue&type=script&lang=js"
import style0 from "./sendRecord.vue?vue&type=style&index=0&id=34c66d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c66d8e",
  null
  
)

export default component.exports